import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({})
export default class SellOutText extends Vue {
  @Prop({ default: () => {} })
    value: ItemObject;

  render(h) {
    return (
      <div class="text-black bg-white r-py-8 r-px-12">
        <div class="text-red font-size-16 font-bold">{this.value.isPre ? this.value.desc.sellOutText : '￥XXXX(点击设置售罄文本)'}</div>
        <div class="flex hei-20">
          <div class="line-height-40 flex1">XXXXXXXXXX</div>
          <div class="flex font-size-4 text-grey-15" style="width: 20%;">
            <div class="r-mr-12 center">
              <i class="iconfont iconshoucang-01 font-size-14"></i>
              <p class="font-size-4">收藏</p>
            </div>
            <div class="center">
              <i class="iconfont iconfenxiang-01 font-size-14"></i>
              <p class="font-size-4">分享</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
